@if (isInitialized) {
  <oe-components-scheduler (schedule)="(schedule)" [(payload)]="payload">
    <ng-template let-task="task">
      {{ ("BRAIINS_SINGLE.SCHEDULE.MODE" | translate) + " " + task.payloadText }}
    </ng-template>
  </oe-components-scheduler>
}
